import React, { Component } from "react";
import styles from "./cmsHowenVideosat.module.scss";
import { withVideoDevices } from "../../../../shared/containers/containerVideoDevices";
import { dateGridLocalTextOptions } from "../../../../shared/services/dataGridLocalTextOptions";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { states } from "../../../../reducers/queriesStates";

class CmsHowenVideosat extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSelected: false,
    };
  }

  componentDidMount() {
    const { onGetVideiDevices, companyId } = this.props;

    onGetVideiDevices({ companyId });
  }

  componentDidUpdate(preProps) {
    const { videoDevicesDataState, videoDeviceCreateDataState, videoDeviceDeleteDataState, videoDevices, unit } = this.props;

    if (
      (videoDevicesDataState === states.READY && preProps.videoDevicesDataState === states.REQUEST) ||
      (videoDeviceCreateDataState === states.READY && preProps.videoDeviceCreateDataState === states.REQUEST) ||
      (videoDeviceDeleteDataState === states.READY && preProps.videoDeviceDeleteDataState === states.REQUEST)
    ) {
      const isSelected = videoDevices.some((x) => {
        return x.unit !== null && x.unit.id === unit.id;
      });

      this.setState({ isSelected });
    }
  }

  onCreate(howenDeviceId, channels) {
    const { onCreateVideiDevice, unit } = this.props;

    onCreateVideiDevice(
      { unitId: unit.id, howenDeviceId, channels },
      { id: unit.id, title: unit.title, registerNumber: unit.registerNumber }
    );
  }

  onDelete(howenDeviceId) {
    const { onDeleteVideiDevice, unit } = this.props;

    onDeleteVideiDevice({ id: unit.id }, howenDeviceId);
  }

  getColumns() {
    const { unit } = this.props;
    const { isSelected } = this.state;

    return [
      {
        field: "title",
        headerName: "Наименование",
        width: 250,
      },
      {
        field: "model",
        headerName: "Модель",
        width: 160,
      },
      {
        field: "channels",
        headerName: "Каналы",
        width: 160,
        renderCell: (cellValues) => {
          let value = "";

          if ((cellValues.value & 1) !== 0) {
            value += "CH1;";
          }
          if ((cellValues.value & 2) !== 0) {
            value += "CH2; ";
          }

          if ((cellValues.value & 4) !== 0) {
            value += "CH3; ";
          }

          if ((cellValues.value & 8) !== 0) {
            value += "CH4; ";
          }

          return value;
        },
      },
      {
        field: "unitTitle",
        headerName: "ТС",
        width: 160,
      },
      {
        field: "registerNumber",
        headerName: "Рег. номер",
        width: 160,
      },
      {
        field: "deleteField",
        headerName: " ",
        width: 100,
        renderCell: (cellValues) => {
          if (!isSelected && cellValues.row.unitId === null) {
            return (
              <div>
                <ControlPointIcon
                  fontSize="small"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    this.onCreate(cellValues.id, cellValues.row.channels);
                  }}
                />
              </div>
            );
          }

          if (cellValues.row.unitId === unit.id && isSelected) {
            return (
              <div>
                <DeleteIcon
                  fontSize="small"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onDelete(cellValues.id);
                  }}
                />
              </div>
            );
          }

          return null;
        },
      },
    ];
  }

  getRows() {
    const { videoDevices } = this.props;

    return videoDevices.map((x) => {
      return {
        id: x.id,
        title: x.title,
        model: x.model,
        channels: x.channels,
        unitId: x.unit !== null ? x.unit.id : null,
        unitTitle: x.unit !== null ? x.unit.title : null,
        registerNumber: x.unit !== null ? x.unit.registerNumber : null,
      };
    });
  }

  render() {
    return (
      <div className={styles.cmsHowenVideosatContainer}>
        <div className={styles.tableContainer}>
          <DataGrid
            rowHeight={30}
            ref={"DataGrid"}
            localeText={{
              ...dateGridLocalTextOptions,
              columnMenuUnsort: "По умолчанию",
              columnMenuSortAsc: "По возрастанию",
              columnMenuSortDesc: "По убыванию",
              footerRowSelected: (count) => `Cтрок выбранно: ${count}`,
              MuiTablePagination: {
                disabled: false,
                rowsPerPage: 100,
                rowsPerPageOptions: 100,
                labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} из ${count === -1 ? `больше ${to}` : count}`,
              },
            }}
            rows={this.getRows()}
            columns={this.getColumns()}
            disableRowSelectionOnClick
          />
        </div>
      </div>
    );
  }
}

export default withVideoDevices(React.memo(CmsHowenVideosat));
